// The City College of New York's bachelor's programs (#2739). Read on
// 2026-10-01 from City College's official undergraduate catalog
// (ccny-undergraduate.catalog.cuny.edu, CUNY's catalog host), Programs: all
// 135 entries, read in a browser page by page. The list gives no college or
// school for each program, so this is one A to Z group. Degree abbreviations
// are the catalog's. Programs the catalog lists more than once under the same
// name and degree (separate codes for Civil, Chemical, Electrical and
// Mechanical Engineering, Biomedical Science, Biotechnology and Childhood
// Education) appear once, and the catalog's separate Macaulay Honors
// College Biotechnology BS line is folded into Biotechnology. Left out: minors, certificates, and the combined bachelor's and
// master's programs (BS/MS, BA/MA).
const majors = {
    "slug": "city-college-of-new-york",
    "read": "2026-10-01",
    "intro": "Every bachelor's program in City College's official undergraduate catalog, A to Z, with the degree it leads to. Minors, certificates and combined bachelor's and master's programs are left out.",
    "groups": [
        {
            "name": "Bachelor's programs, A to Z",
            "source": {
                "label": "City College Undergraduate Catalog, Programs",
                "url": "https://ccny-undergraduate.catalog.cuny.edu/programs"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BARCH"
                },
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art K-12 Teacher",
                    "degree": "BA"
                },
                {
                    "name": "Area Studies: Asian - Latin American and Latino - Russian",
                    "degree": "BA"
                },
                {
                    "name": "Area Studies: Black-Puerto Rican-Jewish",
                    "degree": "BA"
                },
                {
                    "name": "Bilingual Childhood Education",
                    "degree": "BSED"
                },
                {
                    "name": "Bilingual Childhood Education, Grades 1-6",
                    "degree": "BSED"
                },
                {
                    "name": "Biology for Allied Health Professions",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biology Teacher, Grades 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Black Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Biomedical Science",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Childhood Education",
                    "degree": "BSED"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry Teacher, Grades 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Communications",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Digital Game Development",
                    "degree": "BS"
                },
                {
                    "name": "Earth Science Teacher, Grades 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Electronic Design and Multimedia",
                    "degree": "BFA"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "English Teacher, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BBA"
                },
                {
                    "name": "Environmental and Earth Systems Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Atmospheric Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Atmospheric Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Earth Systems Science and Environmental Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Film",
                    "degree": "BFA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Liberal Arts and Sciences (Worker Education)",
                    "degree": "BA"
                },
                {
                    "name": "International and Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jazz Studies Instrumental",
                    "degree": "BMUS"
                },
                {
                    "name": "Jazz Studies (Vocal)",
                    "degree": "BMUS"
                },
                {
                    "name": "Romance Languages: French, Italian, Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Teacher, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BE"
                },
                {
                    "name": "Management and Administration",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics Teacher, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics Teacher, Grades 7-12",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Popular Music Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Science Learning & Public Engagement",
                    "degree": "BS"
                },
                {
                    "name": "Social Justice and Urban Life",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sonic Arts",
                    "degree": "BMUS"
                },
                {
                    "name": "Social Studies Teacher, Grades 7-12",
                    "degree": "BA"
                },
                {
                    "name": "Strategic Management",
                    "degree": "BBA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies and the Built Environment",
                    "degree": "BA"
                }
            ]
        }
    ]
};

export default majors;
